/**
 * @generated SignedSource<<de1eebec837c85ce4cd5c110f9218242>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompletionPeriodType = "ALL_TIME" | "BEFORE_NEXT_WEEK" | "BEFORE_NOW" | "LAST_30_DAYS" | "LAST_7_DAYS" | "LAST_WEEK" | "THIS_WEEK" | "%future added value";
export type MeasurementType = "BODYFAT" | "BODYWEIGHT" | "CALF" | "CHEST" | "HIP" | "SHOULDER" | "STEP_COUNT" | "THIGH" | "UPPER_ARM" | "WAIST" | "%future added value";
export type ClientMeasurementScreenRefetchQuery$variables = {
  id: string;
  includeMeasurement: boolean;
  includeNutrition: boolean;
  measurementType?: MeasurementType | null | undefined;
  period?: CompletionPeriodType | null | undefined;
};
export type ClientMeasurementScreenRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"ClientMeasurementScreen_client">;
  } | null | undefined;
};
export type ClientMeasurementScreenRefetchQuery = {
  response: ClientMeasurementScreenRefetchQuery$data;
  variables: ClientMeasurementScreenRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeMeasurement"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeNutrition"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "measurementType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "period"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v6 = {
  "kind": "Variable",
  "name": "measurementType",
  "variableName": "measurementType"
},
v7 = {
  "kind": "Variable",
  "name": "period",
  "variableName": "period"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "carbsGrams",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "proteinGrams",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fatGrams",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calories",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientMeasurementScreenRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "includeMeasurement",
                "variableName": "includeMeasurement"
              },
              {
                "kind": "Variable",
                "name": "includeNutrition",
                "variableName": "includeNutrition"
              },
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ClientMeasurementScreen_client"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ClientMeasurementScreenRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "username",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "units",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientNutritionTarget",
                "kind": "LinkedField",
                "name": "nutritionTarget",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "trackingType",
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "condition": "includeNutrition",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      (v7/*: any*/)
                    ],
                    "concreteType": "ClientNutritionEntryConnection",
                    "kind": "LinkedField",
                    "name": "clientNutritionEntries",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClientNutritionEntryEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClientNutritionEntry",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "notes",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "date",
                                "storageKey": null
                              },
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ClientNutritionTarget",
                                "kind": "LinkedField",
                                "name": "target",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v9/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              },
              {
                "condition": "includeMeasurement",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      (v6/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "metricType",
                        "value": "CHECKIN_ANSWER_MEASUREMENT"
                      }
                    ],
                    "concreteType": "ClientMetric",
                    "kind": "LinkedField",
                    "name": "metrics",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": "x",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "format",
                            "value": "YYYY-MM-DD"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "activityDate",
                        "storageKey": "activityDate(format:\"YYYY-MM-DD\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "measurement",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unit",
                                "storageKey": null
                              }
                            ],
                            "type": "CheckinAnswerMeasurementValue",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "raw",
                            "value": true
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "activityDate",
                        "storageKey": "activityDate(raw:true)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b755773686fef3742bccc3bac0699dd2",
    "id": null,
    "metadata": {},
    "name": "ClientMeasurementScreenRefetchQuery",
    "operationKind": "query",
    "text": "query ClientMeasurementScreenRefetchQuery(\n  $includeMeasurement: Boolean!\n  $includeNutrition: Boolean!\n  $measurementType: MeasurementType\n  $period: CompletionPeriodType\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ClientMeasurementScreen_client_1TZTQz\n    id\n  }\n}\n\nfragment ClientMeasurementChart_metrics on ClientMetric {\n  id\n  x: activityDate(format: \"YYYY-MM-DD\")\n  value {\n    __typename\n    ... on CheckinAnswerMeasurementValue {\n      measurement\n      unit\n    }\n  }\n}\n\nfragment ClientMeasurementRows_metrics on ClientMetric {\n  id\n  activityDate(raw: true)\n  name\n  value {\n    __typename\n    ... on CheckinAnswerMeasurementValue {\n      measurement\n      unit\n    }\n  }\n}\n\nfragment ClientMeasurementScreen_client_1TZTQz on User {\n  id\n  username\n  units\n  nutritionTarget {\n    trackingType\n    id\n  }\n  clientNutritionEntries(period: $period) @include(if: $includeNutrition) {\n    edges {\n      node {\n        ...ClientNutritionResults_nutritionEntries\n        id\n      }\n    }\n  }\n  metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: $measurementType) @include(if: $includeMeasurement) {\n    ...ClientMeasurementChart_metrics\n    ...ClientMeasurementRows_metrics\n    id\n  }\n}\n\nfragment ClientNutritionNotesDialog_nutritionEntry on ClientNutritionEntry {\n  notes\n  date\n}\n\nfragment ClientNutritionResultsWeek_nutritionEntries on ClientNutritionEntry {\n  ...ClientNutritionNotesDialog_nutritionEntry\n  id\n  date\n  carbsGrams\n  proteinGrams\n  fatGrams\n  calories\n  notes\n  target {\n    calories\n    carbsGrams\n    proteinGrams\n    fatGrams\n    id\n  }\n}\n\nfragment ClientNutritionResults_nutritionEntries on ClientNutritionEntry {\n  ...ClientNutritionResultsWeek_nutritionEntries\n  id\n  date\n}\n"
  }
};
})();

(node as any).hash = "420217c549b0eee78b326d4e57d9522b";

export default node;
